import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 13.449 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.449 16\" id=\"icon-user\">\r\n  <path id=\"icon-user_账号_1_\" data-name=\"账号 (1)\" d=\"M154.494,55.416a4.087,4.087,0,1,0-.885-1.325,4.121,4.121,0,0,0,.885,1.325Zm6.159,2.13H154.11a3.453,3.453,0,0,0,0,6.905h6.544a3.453,3.453,0,1,0,0-6.905Z\" transform=\"translate(-150.657 -48.451)\" fill=\"#333\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol